document.querySelectorAll('.collection-list.contains-card .card').forEach(card => {
  const link = card.querySelector('.card__inner a');
  if (link && link.href) {
    card.addEventListener('click', () => {
      window.location.href = link.href;
    });
    card.style.cursor = 'pointer'; // Optional, if you prefer JS over CSS
  }
});


document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.coll_listing li');

  items.forEach(function (li) {
    const link = li.querySelector('a');

    if (link && link.href) {
      li.style.cursor = 'pointer'; // Optional: show pointer on hover

      li.addEventListener('click', function (e) {
        // Prevent redirect if the actual <a> was clicked
        if (!e.target.closest('a')) {
          window.location.href = link.href;
        }
      });
    }
  });
});


function moveProductElements() {
  const isMobile = window.innerWidth <= 768;

  document.querySelectorAll('.product.product--medium').forEach(product => {
    const title = product.querySelector('.product__title');
    const rating = product.querySelector('.rating-wrapper');
    const mediaWrapper = product.querySelector('.grid__item.product__media-wrapper');
    const contentWrapper = product.querySelector('.product__info-container');

    if (!title || !rating || !mediaWrapper || !contentWrapper) return;

    if (isMobile) {
      // Only move if not already moved
      if (!mediaWrapper.previousElementSibling?.classList.contains('product__title')) {
        mediaWrapper.parentNode.insertBefore(title, mediaWrapper);
        mediaWrapper.parentNode.insertBefore(rating, mediaWrapper);
      }
    } else {
      // Restore original position if not already there
      if (!contentWrapper.contains(title)) contentWrapper.appendChild(title);
      if (!contentWrapper.contains(rating)) contentWrapper.appendChild(rating);
    }
  });
}

// Initial run
document.addEventListener('DOMContentLoaded', moveProductElements);

// Debounced resize handler
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(moveProductElements, 200);
});




document.addEventListener("DOMContentLoaded", function() {
  // Target specific section buttons
  const section = document.querySelector('section#shopify-section-template--19034130776278__1635281307818b35b3');
  if (section) {
    const buttons = section.querySelectorAll('a.button.button--primary');
    buttons.forEach(button => {
      button.setAttribute('target', '_blank');
    });
  }

  // Target all external links to elevatedsprayfoam.com
  const externalLinks = document.querySelectorAll('a[href="https://www.elevatedsprayfoam.com"]');
  externalLinks.forEach(link => {
    link.setAttribute('target', '_blank');
  });
});

